module.exports = __webpack_public_path__ + "static/media/aevo.de1a4201.png";


//////////////////
// WEBPACK FOOTER
// ./src/aevo.png
// module id = 424
// module chunks = 0